/**
 * Created by ren on 12/07/2017.
 */

import * as apiUtils from '../apiUtils';
import * as apiCommon from '../apiCommon';
import * as docTypes from '../../constants/constant_doc_types';

export const saveDoc = (app, params) => {
  const { user = {}, data } = params;

  const shippingMethod = {
    doc_type: docTypes.SHIPPING_METHOD,
    active: apiUtils.toBoolean(data.active),
    name: apiUtils.toStringText(data.name),
    description: apiUtils.toStringText(data.description),
    enable_split: apiUtils.toBoolean(data.enable_split),
    reallocate: apiUtils.toBoolean(data.reallocate),
  };

  return apiCommon.saveDoc(app, { source: data, doc: shippingMethod, user });
};

export const deleteDoc = (app, params) =>
  apiCommon.deleteDoc(app, {
    id: params.id,
    docType: docTypes.SHIPPING_METHOD,
  });

export const fetchDocById = (app, params) => {
  const { id } = params;
  const docType = docTypes.SHIPPING_METHOD;
  return apiCommon.getDoc(app, { id, docType });
};
